import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PackingBoxCreateLabelType } from '../../../../views/packing-box/types/create-label-dialog';
import { PackingBoxCreateLabelComponent } from '../../../../views/packing-box/dialog/create-label/create-label.component';
import { PackingBoxCreateLabelFormDirective } from '../../../../views/packing-box/dialog/create-label/create-label.directive';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { WorkOrderBatch } from '../../../../api/elite/types/work-order-batch';
import { CompoundingCreateLabelService } from './create-label.service';
import { PackingBoxCreateLabelService } from '../../../../views/packing-box/dialog/create-label/create-label.service';

export type CompoundingPackingBoxCreateLabelType = {
  data: DataInfo;
  response: ResponseInfo;
};
type DataInfo = PackingBoxCreateLabelType['data'] & {
  batches?: WorkOrderBatch[];
};
type ResponseInfo = PackingBoxCreateLabelType['response'] & {
  workOrderBatchId?: number;
  batch: string;
};
@Component({
  selector: 'app-create-label',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
    PackingBoxCreateLabelComponent,
    PackingBoxCreateLabelFormDirective,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './create-label.component.html',
  styleUrls: ['./create-label.component.sass'],
  providers: [
    {
      provide: PackingBoxCreateLabelService,
      useClass: CompoundingCreateLabelService,
    },
  ],
})
export class CompoundingPackingBoxCreateLabelComponent implements OnInit {
  readonly data: DataInfo = inject(MAT_DIALOG_DATA);
  private readonly service = inject(
    PackingBoxCreateLabelService
  ) as CompoundingCreateLabelService;

  get form() {
    return this.service.formBatches;
  }

  filteredBatches = this.data.batches;

  ngOnInit(): void {
    if (this.data.batches.length > 0) {
      this.service.setBatchesToRequired();
      this.form.get('search').valueChanges.subscribe((value = null) => {
        if (!value) {
          this.filteredBatches = this.data.batches;
        } else {
          this.filteredBatches = this.data.batches.filter((val) =>
            this.getStringBatch(val).toUpperCase().includes(value.toUpperCase())
          );
        }
      });
    }
  }

  getStringBatch(val: WorkOrderBatch): string {
    return `${val.batch.workOrder.transactionNumber} | ${val.batch.batchNumber}`;
  }
}
